import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

const LABEL_MAP = {
    search: 'react_search',
    tripSummary: 'react_tripsummary',
};

function externalDirectionsLinkClicked({
    nearby,
    stationId,
    tripId,
    type,
    waypointType,
}) {
    const eventCategory = LABEL_MAP[type];

    let property = {
        nearby_station: nearby,
        station_id: stationId,
    };

    if (tripId) {
        property.trip_id = tripId;
    }

    SnowplowService.fireStructuredEvent({
        action: 'click',
        category: eventCategory,
        label: 'view_directions',
        property,
    });

    amplitude.track('map_opened', {
        funnel_stage: type === 'tripSummary'
            ? 'trip_summary'
            : 'search',
        nearby_station: nearby,
        station_id: stationId,
        trip_id: tripId,
        waypoint_type: waypointType,
    });
}

export default { externalDirectionsLinkClicked };
